// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/~/core-js/library/modules/es6.array.is-array.js
// module id = 497
// module chunks = 0